import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { fetchIfNotLoaded } from '@core/ngrx-legacy';
import type { SeatKind } from '@core/tellent-types';

import { TellentAppsActions, TellentAppsSelectors } from './tellent-apps.store';
import { OrganizationChannelActions } from '../../organization';

@Injectable({
  providedIn: 'root',
})
export class TellentAppsDataService {
  private readonly actions$ = inject(Actions);
  public store = inject(Store);

  public apps$ = this.store.pipe(
    this.fetchIfNotLoaded(),
    select(TellentAppsSelectors.allEntities),
    filterDefined,
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  public appsLoaded$ = this.store.pipe(
    select(TellentAppsSelectors.isLoaded()),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor() {
    this.setupRefresh();
  }

  public getAppBySeatKind(kind: SeatKind) {
    return this.store.pipe(
      this.fetchIfNotLoaded(),
      select(TellentAppsSelectors.selectAppBySeatKind(kind)),
      filterDefined,
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  public getAppBySeatKindIfExist(kind: SeatKind) {
    return this.store.pipe(
      this.fetchIfNotLoaded(),
      select(TellentAppsSelectors.selectAppBySeatKind(kind)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  private fetchIfNotLoaded() {
    return fetchIfNotLoaded(this.store.select(TellentAppsSelectors.meta()), () =>
      this.store.dispatch(TellentAppsActions.fetchCollection()),
    );
  }

  private setupRefresh() {
    this.actions$
      .pipe(ofType(OrganizationChannelActions.subscriptionUpdated))
      .subscribe(() => this.store.dispatch(TellentAppsActions.fetchCollection()));
  }
}
